<template>
  <q-dialog v-model="props.dialog">
    <q-card>
      <div class="q-pa-xs">
        <q-list bordered
                separator>
          <q-item>
            <q-item-section>
              <q-select dense
                        v-model="opts.Motivo"
                        :rules="[(val) => (val && val.length > 0) || 'Selecciona']"
                        :options="motivos"
                        label="Motivo"></q-select>
            </q-item-section>
          </q-item>
          <q-item v-if="opts.Motivo == 'Otros'">
            <q-item-section>
              <q-input label="Define motivo de baja"
                       clearable
                       dense
                       v-model="opts.Defmotivo"
                       autogrow></q-input>
            </q-item-section>
          </q-item>
          <q-item v-if="!opts.Motivo.includes('Suspensión') && opts.Motivo !== ''">
            <q-item-section>
              <q-checkbox left-label
                          v-model="opts.Recuperable"
                          label="¿Cliente recuperable?" />
            </q-item-section>
          </q-item>
          <q-item v-if="opts.Recuperable == true">
            <q-item-section>
              <q-input label="Notas"
                       clearable
                       dense
                       v-model="opts.Notas"
                       autogrow></q-input>
            </q-item-section>
          </q-item>
          <q-item>
            <q-uploader :url="url"
                        auto-upload
                        label="Subir justificante"
                        field-name="file"
                        :form-fields="[
                          { name: 'folder', value: global.user.area + '/PolizasBajas' },
                          { name: 'name', value: props.data.Poliza },
                        ]"
                        multiple
                        @uploaded="onUpload"
                        style="max-width: 300px"></q-uploader>
          </q-item>
          <q-item v-ripple>
            <q-item-section>
              <q-btn label="Cancelar"
                     color="negative"
                     @click="cancel"></q-btn>
            </q-item-section>
            <q-item-section>
              <q-btn label="Aceptar"
                     color="primary"
                     @click="send"></q-btn>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
    </q-card>
  </q-dialog>

  <q-dialog v-model="showConfirmMailDialog">
    <q-card>
      <q-card-section class="row items-center">
        <q-avatar icon="mail"
                  color="primary"
                  text-color="white"
                  size="md" />
        <span class="q-ml-sm">¿Desea enviar el correo de baja de póliza?</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat
               label="No"
               color="negative"
               @click="sendMail(false)" />
        <q-btn flat
               label="Sí"
               color="primary"
               @click="sendMail(true)" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { inject, onMounted, ref, watch } from "vue";
import { Notify } from "quasar";
const props = defineProps({ data: {}, dialog: false });
const emit = defineEmits(["dialog"]);
const global = inject("global");
const optsInit = { Motivo: "", Defmotivo: "", Notas: "", Recuperable: false };
const opts = ref(optsInit);
const url =
  window.location.protocol + "//" + window.location.hostname + "/docs/upload";
const motivos = ref([
  "No responde, desconocido",
  "Prima/Condiciones competencia",
  "Servicio",
  "Suspensión Venta",
  "Suspensión Baja definitiva",
  "Cambio Mediador",
  "Otros",
]);
const uploaded = ref(0);
const showConfirmMailDialog = ref(false);

async function send() {
  if (opts.value.Defmotivo) opts.value.Motivo = opts.value.Defmotivo;
  let FechaBaja = opts.value.Motivo.includes("Suspensión") && global.data.getDate() < props.data.Fecha
    ? global.data.getDate()
    : props.data.Fecha;
  let FechaAgenda = new Date(new Date().setDate(new Date().getDate() + 30))
    .toISOString()
    .slice(0, 10);

  let data = [
    {
      table: "Polizas",
      query: "update",
      data: { Bloq: 1, Estado: "AN" },
      where: { id: props.data.id, Poliza: props.data.Poliza },
    },
    {
      table: "PolizasGestion",
      query: "inserti",
      data: {
        Fecha: FechaBaja,
        Poliza: props.data.Poliza,
        Motivo: opts.value.Motivo,
        Recuperable: opts.value.Recuperable,
        Notas: opts.value.Notas,
        Usuario: global.user.name,
      }
    },
    {
      table: "Recibos",
      query: "update",
      data: { FechaAgenda: FechaAgenda },
      where: { Poliza: props.data.Poliza }
    }
  ];

  opts.value.Recuperable = Number(opts.value.Recuperable);
  if (opts.value.Recuperable == 1) {
    data = [...data, {
      table: "PolizasCompetencia",
      query: "inserti",
      data: {
        Fecha: (new Date(new Date(FechaBaja).setFullYear(new Date(FechaBaja).getFullYear() + 1))).toISOString().split('T')[0],
        Poliza: props.data.Poliza,
        Empresa: "Salida TOTSEGUR",
        NIF: props.data.NIF,
        Cliente: props.data.Cliente,
        Coberturas: props.data.Coberturas,
        Riesgo: props.data.Riesgo,
        Pago: props.data.Pago,
        Responsable: props.data.Responsable,
        Importe: props.data.Importe,
        Mediador: props.data.Mediador
      }
    }]
  }

  await global.db("/app/db/BajaPoliza", data, false);

  showConfirmMailDialog.value = true;
}

async function sendMail(confirm) {
  showConfirmMailDialog.value = false;
  if (confirm) {
    console.log("Correo");
    const tmp = await global.db("/app/db", { table: "Plantillas", query: "get", where: { Nombre: "BajaPoliza" } });
    if (tmp.success == true) {
      let Firma = "Agencia Reale, mediador: " + global.user.area;
      let Para = tmp.data[0].Para;
      let Empresa = "Sucursal";
      if (props.data.SM > 8999) {
        const sm = await global.db("/app/db", { table: "Colaboradores", query: "get", where: { SM: props.data.SM, Mediador: global.user.area } });
        Firma = "";
        Para = sm.data[0].Correo;
        Empresa = sm.data[0].Nombre;
      }
      let Cc = "";
      let FechaBaja = opts.value.Motivo.includes("Suspensión") && global.data.getDate() < props.data.Fecha
        ? global.data.getDate()
        : props.data.Fecha;
      let FechaAgenda = new Date(new Date().setDate(new Date().getDate() + 30))
        .toISOString()
        .slice(0, 10);
      let data = { ...props.data, ...opts.value, FechaBaja, FechaAgenda, Usuario: global.user.name, Firma, Empresa };
      let Mensaje = global.data.replace(tmp.data[0].Mensaje, data);
      let Asunto = global.data.replace(tmp.data[0].Asunto, data);
      global.db("/app/sendMail/CorreoBajaPoliza", { data: { Para, Cc, Asunto, Mensaje } }, false);
    }
  }
  opts.value = optsInit;
  emit("dialog", true);
}

function cancel() {
  opts.value = optsInit;
  emit("dialog", true);
}
function onUpload(info) {
  let res = JSON.parse(info.xhr.response);
  if (res.error) {
    uploaded.value = 0;
    Notify.create({
      message: res.error,
      color: "negative",
      position: "top",
    });
  } else {
    uploaded.value = 1;
    Notify.create({
      message: "Archivo subido correctamente",
      color: "positive",
      position: "top",
    });
  }
}
</script>
